import React from "react";
import { FiSearch } from "react-icons/fi";

/**
 * Search Bar Component
 * Global search input for admin panel
 */
const SearchBar = () => {
  return (
    <div className="relative hidden md:block">
      <input
        type="text"
        placeholder="Search..."
        className="w-64 pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
      />
      <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
    </div>
  );
};

export default SearchBar;
